import { CtaButton } from '@/components/astro/cta-button/cta-button';
import * as m from '@/paraglide/messages';
import IconBlueBook from '@listening/assets/astro/icons/new-design-25/features-page/icon-blue-book.svg?react';
import IconBluePlay from '@listening/assets/astro/icons/new-design-25/features-page/icon-blue-play.svg?react';
import IconBlueSquare from '@listening/assets/astro/icons/new-design-25/features-page/icon-blue-square.svg?react';
import jumpToTheListenTo from '@listening/assets/astro/images/new-design-25/features-page/jump-to-the-listen.png';

export function JumpToTheListenTo() {
  return (
    <section className='mx-auto max-w-[1600px] px-4 py-16 sm:px-6 md:py-24 lg:px-8'>
      <div className='flex flex-col items-center lg:flex-row lg:justify-between lg:gap-12'>
        {/* <!-- Image section - appears first on mobile/tablet, second on lg screens --> */}
        <div className='relative order-1 mb-10 w-full max-w-xl lg:order-2 lg:mb-0'>
          <img
            alt='Scan Papers feature illustration'
            className='h-auto w-full'
            height={400}
            src={jumpToTheListenTo}
            width={600}
            // quality={100}
            // format="png"
          />
        </div>

        {/* <!-- Text content section - appears second on mobile/tablet, first on lg screens --> */}
        <div className='order-2 max-w-4xl text-center lg:order-1 lg:max-w-2xl lg:text-left'>
          {/* <!-- <div className="mb-6 flex justify-center lg:justify-start">
        <ScanPapersIcon className="size-12" />
      </div> --> */}
          <h2 className='mx-auto mb-6 max-w-2xl text-3xl leading-tight font-bold text-black sm:text-6xl lg:mx-0'>
            {m.features_jump_title()}
          </h2>
          <ul className='mb-8 space-y-5 text-neutral-665 sm:text-lg'>
            <li className='flex items-start'>
              <IconBlueSquare className='mr-2 size-6' />
              {m.features_jump_bullet_1()}
            </li>
            <li className='flex items-start'>
              <IconBluePlay className='mr-2 size-6' />
              {m.features_jump_bullet_2()}
            </li>
            <li className='flex items-start'>
              <IconBlueBook className='mr-2 size-6' />
              {m.features_jump_bullet_3()}
            </li>
          </ul>
          <div className='flex justify-center lg:justify-start'>
            <CtaButton
              className='h-10 bg-royal-50 px-8 py-7 text-xl font-light text-white hover:bg-royal-50/90'
              label={m.features_jump_cta()}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
